@if (customFooter) {
  <p [innerHTML]="customFooter"></p>
} @else {
  <p>{{'l_copyright' | i18n}} {{currentYear}}</p>
}

